<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
        >
          <el-input
            v-model="searchForm.ruletype_name"
            placeholder="规格分类名称"
            width="50"
          />
        </el-form-item>

        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="add"
    >
      新增
    </el-button>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="ID"
      >
        <template slot-scope="scope">
          {{scope.row.id}}
        </template>
      </el-table-column>
      <el-table-column
        label="规格分类名称"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.ruletype_name}}
        </template>
      </el-table-column>
      <el-table-column
              label="排序"
              prop="ruletype_sort"
              sortable="custom"
              :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{scope.row.ruletype_sort}}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="250"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain  size="mini"  @click="openEditForm(scope.row)">修改</el-button>
          <el-button type="primary" plain  size="mini"   @click="openCloudruleForm(scope.row)">规格配置</el-button>
          <el-button type="primary" plain  size="mini"  @click="del(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <edit-form
      :oneclass="oneclass"
      v-model="editFormVisible"
      @submit="getTableData"
    />

    <cloudrule-form
            :agent="oneclass"
            v-model="cloudruleFormVisible"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
    import * as agentService from "@/api/sys/agent";
import editForm from "./editForm";
    import util from '@/libs/util.js';
    import cloudruleForm from "./cloudruleForm";
export default {
  name: "RuletypePage",
  components: { editForm ,cloudruleForm},
  data() {
    return {
      searchForm: {
          advTitle: ""
      },
      loading: false,
      tableData: [],
      multipleSelection: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
      editFormVisible: false,
        cloudruleFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          agentid: util.cookies.get('agentid'),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
        agentService.getRuletypePageList(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
      openCloudruleForm(oneclass) {
          this.oneclass = oneclass;
          this.cloudruleFormVisible = true;
      },
    openEditForm(oneclass) {
      this.oneclass = oneclass;
      this.editFormVisible = true;
    },
    add() {
      this.oneclass = {};
      this.editFormVisible = true;
    },
    batchDel() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          agentService
          .delRuleTypes({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData();
          });
      });
    },
    del(id) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          agentService.delRuleType({id:id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
